import classNames from 'classnames'
import React, { ReactNode, useMemo } from 'react'

import { Tooltip } from 'core-components/library/tooltip'
import { RowButtons } from 'partner360/components/rowButtons/RowButtons'

import styles from './SettingsSwitcher.module.scss'

interface IProps<T> {
  activeOption: T
  options: T[]
  onChangeActiveOption: (value: T) => void
  title?: ReactNode
  margin?: 'md'
  isChanged?: boolean
  isDisabled?: boolean
  disabledTooltip?: ReactNode
}

export const SettingsSwitcher = <T extends string>({
  activeOption,
  onChangeActiveOption,
  options,
  title,
  margin,
  isChanged,
  isDisabled = false,
  disabledTooltip,
}: IProps<T>) => {
  const marginStyle = useMemo(
    () => ({
      [styles.marginMd]: margin === 'md',
    }),
    [margin]
  )

  const control = (
    <RowButtons
      value={activeOption}
      options={options}
      generateTranslationKey={(val) => val}
      onOptionClick={(value) => {
        if (!isDisabled) onChangeActiveOption(value)
      }}
      isDisabled={isDisabled}
      background={isChanged ? 'bg-default' : 'bg-white'}
    />
  )

  return (
    <div className={classNames(marginStyle)}>
      {title}
      {isDisabled && disabledTooltip ? (
        <Tooltip inline tipContent={() => <>{disabledTooltip}</>}>
          {control}
        </Tooltip>
      ) : (
        control
      )}
    </div>
  )
}
